'use client'
import {
  Context
} from "./chunk-4NAR6N5F.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/map/timeline/useTimeline.ts
import { useContext, useState } from "react";
import { useTransformEffect } from "react-zoom-pan-pinch";
var useTimeline = () => {
  const context = useContext(Context);
  const [state, setState] = useState(context);
  if (!context) {
    throw new Error("useTimeline must be used within a TimelineProvider");
  }
  useTransformEffect((ref) => {
    const scale = ref.state.scale;
    const currentMode = state.mode;
    const newMode = scale > 3 ? "daily" : "monthly";
    if (newMode !== currentMode) {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { mode: newMode }));
    }
  });
  return __spreadValues(__spreadValues({}, context), state);
};
var useTimeline_default = useTimeline;

export {
  useTimeline_default
};
//# sourceMappingURL=chunk-ZYYXDCUC.mjs.map